import { v as v4 } from '../../v4-c5e36445.js';
export { v as generateId } from '../../v4-c5e36445.js';

var generateBaseGroupId = function generateBaseGroupId() {
  return "base_".concat(v4());
};

export { generateBaseGroupId };
